import { connectedStore } from '../../store';
import actions from '../actions';

const uploadAssetsFromExternalSources = (assets, constraints) =>
  new Promise((resolve, reject) => {
    const store = connectedStore.get();
    store.dispatch(
      actions.createMediaGalleryAssetsFromExternalSources(assets, constraints, resolve, reject)
    );
  });

export default uploadAssetsFromExternalSources;
